import { ApiSuccess, CreditsSurveyAnswersDTO, CreditsSurveyStatus, CreditsSurveySubmitResult, LessonVerdictDTO, TopupIntentResultDTO } from '@superlekcja/shared'
import { api } from '@/services/api'

export async function fetchCreditsSurveyStatus(): Promise<CreditsSurveyStatus> {
  const response = await api.get<ApiSuccess<{ status: CreditsSurveyStatus }>>('/survey/credits')
  return response.data.data.status
}

export async function submitCreditsSurvey(answers: CreditsSurveyAnswersDTO): Promise<CreditsSurveySubmitResult> {
  const response = await api.post<ApiSuccess<{ result: CreditsSurveySubmitResult }>>('/survey/credits', answers)
  return response.data.data.result
}

export async function fetchLessonVerdict(lessonId: string): Promise<LessonVerdictDTO | null> {
  const response = await api.get<ApiSuccess<{ verdict: LessonVerdictDTO | null }>>(`/survey/lesson/${lessonId}`)
  return response.data.data.verdict
}

export async function saveLessonVerdict(lessonId: string, verdict: LessonVerdictDTO): Promise<void> {
  await api.put(`/survey/lesson/${lessonId}`, verdict)
}

export async function recordTopupIntent(): Promise<TopupIntentResultDTO> {
  const response = await api.post<ApiSuccess<TopupIntentResultDTO>>('/survey/topup-intent')
  return response.data.data
}
